export const EFFECT = 'blur';
export const THRESHOLD = '280';
